import React from "react";
import { Box } from "@mui/material";
import colors from "../../styles/colors";

interface LogoLayerProps {
  src: string;
  alt: string;
  left: string;
  zIndex: number;
  onClick: () => void;
  isActive: boolean;
}

const LogoLayer: React.FC<LogoLayerProps> = ({
  src,
  alt,
  left,
  zIndex,
  onClick,
  isActive,
}) => {
  // Calculate the correct index for the filter colors
  // Since zIndex is 6,5,4,3,2,1, we need to map it to 0,1,2,3,4,5
  const layerIndex = 6 - zIndex;

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onClick={onClick}
      sx={{
        position: "absolute",
        left,
        width: "10%",
        zIndex,
        transition:
          "left 0.5s cubic-bezier(0.55, 0.1, 0.15, 1), transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)",
        cursor: "pointer",
        transform: isActive ? "scale(1.08)" : "none",
        filter: isActive ? colors.svgHoverFilters[layerIndex] : "none",
        "&:hover": {
          transform: "scale(1.08)",
          filter: colors.svgHoverFilters[layerIndex],
        },
      }}
    />
  );
};

export default LogoLayer;